import type { CallsWindow, RiskFilter, SentimentFilter } from "../types"

/** The calls list's filters as the page uses them, defaults filled in. */
export type CallsUrlFilters = {
  window: CallsWindow
  minScore?: number
  risk: RiskFilter
  sentiment: SentimentFilter
}

/** The same filters as they sit in the URL: defaults left out. */
export type CallsSearch = {
  window?: CallsWindow
  min_score?: number
  risk?: Exclude<RiskFilter, "all">
  sentiment?: Exclude<SentimentFilter, "all">
}

const WINDOWS: CallsWindow[] = ["1h", "24h", "7d"]
const RISKS: Exclude<RiskFilter, "all">[] = ["high", "elevated", "low"]
const SENTIMENTS: Exclude<SentimentFilter, "all">[] = [
  "positive",
  "neutral",
  "negative",
]

/** `validateSearch` for `/voxsense/calls`: anything unknown is dropped. */
export function parseCallsSearch(search: Record<string, unknown>): CallsSearch {
  const n = Number(search.min_score)
  return {
    window: WINDOWS.find((w) => w === search.window && w !== "24h"),
    min_score:
      search.min_score != null && Number.isInteger(n) && n >= 0 && n <= 100
        ? n
        : undefined,
    risk: RISKS.find((r) => r === search.risk),
    sentiment: SENTIMENTS.find((s) => s === search.sentiment),
  }
}

export function filtersFromSearch(search: CallsSearch): CallsUrlFilters {
  return {
    window: search.window ?? "24h",
    minScore: search.min_score,
    risk: search.risk ?? "all",
    sentiment: search.sentiment ?? "all",
  }
}

export function searchFromFilters(filters: CallsUrlFilters): CallsSearch {
  return {
    window: filters.window === "24h" ? undefined : filters.window,
    min_score: filters.minScore,
    risk: filters.risk === "all" ? undefined : filters.risk,
    sentiment: filters.sentiment === "all" ? undefined : filters.sentiment,
  }
}
